// The vertex input struct, generated from the attribute list.
//
// GLSL declares one `layout(location=N) in T aX;` line per attribute, and
// WGSL declares one field of a struct. Both say the same thing, so both come
// from the one `AttribSpec[]` the program carries: `attribs.test.ts` pins the
// GLSL lines against the list, and this file writes the WGSL from it.
//
// The runtime builds its `GPUVertexBufferLayout` from the same list, so a
// shader, its buffer and its pipeline cannot disagree.

import type { AttribSpec } from '../../gfx/types';

/** The WGSL type of an attribute of one to four floats, by its size. */
const ATTRIB_TYPES: readonly string[] = ['f32', 'vec2f', 'vec3f', 'vec4f'];

/** The WGSL type of an attribute of N floats. */
export function wgslAttribType(size: number): string {
  const type = ATTRIB_TYPES[size - 1];
  if (type === undefined) throw new Error(`fast: no WGSL type for an attribute of ${size} floats`);
  return type;
}

/**
 * The `struct VsIn { … }` text of one attribute list, in list order. The
 * name is fixed, because every vertex entry of the engine takes `VsIn`.
 */
export function wgslVertexInput(attribs: readonly AttribSpec[]): string {
  const lines = attribs.map(
    (a) => `  @location(${a.location}) ${a.name}: ${wgslAttribType(a.size)},`);
  return `struct VsIn {\n${lines.join('\n')}\n}\n`;
}
